import React from "react";

const FloatingNav = ({ t, handlePrevSection, handleNextSection }) => (
  <div className="floating-nav">
    <button
      className="nav-btn icon"
      type="button"
      aria-label={t.navAria.prev}
      onClick={handlePrevSection}
    >
      â†‘
    </button>
    <button
      className="nav-btn icon primary"
      type="button"
      aria-label={t.navAria.next}
      onClick={handleNextSection}
    >
      â†“
    </button>
  </div>
);

export default FloatingNav;
